import styled from "styled-components";
import { CreateButton } from "../Header/Header.styled";

export const CreateCollectionWrapper = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  padding: 10px;
  left: 0;
  top: 0;
  background: #2e2e34b0;
  z-index: 1000;
  overflow-y: scroll;
`;

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 1px solid #fff;
  border-radius: 50%;
  width: 29px;
  height: 29px;
  margin: 0 10px;
  position: absolute;
  right: -45px;
  top: -25px;
  cursor: pointer;
  font-size: 12px;
  line-height: 12px;
  color: #fff;
  transition: 0.2s;
  padding: 0;
  &:hover {
    color: #0088cc;
    border: 1px solid #0088cc;
  }
  @media (max-width: 991.98px) {
    right: 0;
    top: 10px;
    color: ${(props) => props.theme.textColor};
    border: 1px solid ${(props) => props.theme.textColor};
  }
`;

export const CreateCollectionMain = styled.div`
  width: 800px;
  max-width: 100%;
  margin: 90px auto;
  padding: 40px;
  background: ${(props) => props.theme.body};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  position: relative;
  @media (max-width: 767.98px) {
    padding: 15px;
  }
  & h2 {
    font-family: "Inter";
    font-style: normal;
    font-weight: 900;
    font-size: 36px;
    line-height: 126.2%;
    color: ${(props) => props.theme.textColor};
    @media (max-width: 767.98px) {
      font-size: 24px;
    }
  }
`;

export const CreateCollectionButton = styled(CreateButton)`
  width: 100%;
  margin: 15px 0 25px;
  height: 50px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 126.2%;
  @media (max-width: 767.98px) {
    display: flex;
  }
`;

export const CreateCollectionImgWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const CreateCollectionImg = styled.div`
  width: 120px;
  height: 120px;
  background: ${(props) => props.theme.bgColor};
  border: 1px solid ${(props) => props.theme.borderColor};
  border-radius: 50%;
  position: relative;
  & img {
    aspect-ratio: 1/1;
    object-fit: cover;
    max-height: 100%;
    max-width: 100%;
    position: absolute;
    border-radius: 50%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
`;

export const CreateCollectionImgText = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 40px;
  @media (max-width: 767.98px) {
    margin-left: 20px;
    max-width: min-content;
  }
  & button {
    background: ${(props) => props.theme.buttonBg};
    border-radius: 25px;
    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    color: #0088cc;
    border: 1px solid #0088cc;
    width: 130px;
    height: 32px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    & svg {
      margin-right: 10px;
    }
  }
`;

export const CreateCollectionLinks = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FileLabel = styled.label`
  display: flex;
  flex-direction: column;
  padding: 10px;
  background: ${(props) => props.theme.bgColor};
  border: 1px solid ${(props) => props.theme.borderColor};
  border-radius: 10px;
  width: 100%;
  height: 350px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-family: "Inter";
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 145.7%;
  text-align: center;
  color: ${(props) => props.theme.subtitleColor};
  & input {
    display: none;
  }
  & button {
    background: ${(props) => props.theme.buttonBg};
    border-radius: 25px;
    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    color: #0088cc;
    border: 1px solid #0088cc;
    width: 130px;
    height: 32px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    pointer-events: none;
    & svg {
      margin-right: 10px;
    }
  }
`;

export const Icon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 1px solid ${(props) => props.theme.borderColor};
  border-radius: 50%;
  width: 30px;
  height: 30px;
  margin: 0 10px;
  position: absolute;
  left: 0;
  & svg {
    width: 55%;
    height: auto;
    & path {
      fill: ${(props) => props.theme.textColor};
    }
  }
`;
